import React from 'react';

const style = {
  display: 'inline-block',
  userSelect: 'none',
  flexShrink: 0,
};

const EditIcon = ({ color = 'black', style: overrideStyles = {}, ...attr }) => {
  return (
    <svg style={{ ...style, ...overrideStyles }} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <path d="M11.2929 3.19313L2.98603 11.5H0.5V9.02664L8.80713 0.707365L11.2929 3.19313Z" stroke={color} />
    </svg>
  );
};

export default EditIcon;
